import React from 'react';
import { Shield, CheckCircle2, Award, Globe2 } from 'lucide-react';
import { CONTACT_CONFIG } from '../config/contact';
export function TrustBar() {
  const trustSignals = [{
    icon: <Shield className="w-6 h-6 text-blue-700" data-id="element-145" />,
    title: 'Accepted by USCIS',
    subtitle: 'and Immigration'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-blue-700" data-id="element-146" />,
    title: 'Certified Translation',
    subtitle: 'and signed'
  }, {
    icon: <Award className="w-6 h-6 text-blue-700" data-id="element-147" />,
    title: CONTACT_CONFIG.ATA_MEMBER,
    subtitle: CONTACT_CONFIG.YEARS_EXP
  }, {
    icon: <Globe2 className="w-6 h-6 text-blue-700" data-id="element-148" />,
    title: 'Over 50 Languages',
    subtitle: 'Native and certified'
  }];
  return <section className="bg-gray-50 border-y border-gray-200 py-8" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-151">
          {trustSignals.map((signal, index) => <div key={index} className="flex flex-col items-center text-center gap-2" data-id="element-152">
              <div className="bg-blue-100 p-3 rounded-full" data-id="element-153">{signal.icon}</div>
              <div data-id="element-154">
                <p className="font-bold text-gray-900 text-sm md:text-base leading-tight" data-id="element-155">
                  {signal.title}
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-0.5" data-id="element-156">
                  {signal.subtitle}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}